<template>
  <v-container class="rp-point pa-0 ma-0">
    <!-- 地点一覧 -->
    <v-col class="com-mb-card-contents-none-border rp-point-card pt-1 mb-0 ">
      <v-col class="com-mb-card-contents rp-point-contents pa-0">
        <div class="rp-box">
          <v-simple-table dense light class="rp-table">
            <thead>
              <tr>
                <th class="rp-item-radio py-0 pl-2 pr-0">
                  {{ text.select }}
                  <v-tooltip right max-width="300">
                    <template v-slot:activator="{ on }">
                      <v-icon light v-on="on">help_outline</v-icon>
                    </template>
                    <span>{{ text.myTimelineText }}</span>
                  </v-tooltip>
                </th>
                <th class="rp-item-name py-0 px-1">{{ text.pointName }}</th>
                <th class="rp-item-location py-0 px-0">{{ text.location }}</th>
                <th class="rp-item-riskInfo py-0 px-0">{{ text.riskInfo }}</th>
                <th class="rp-item-del py-0 px-0">{{ text.delete }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, idx) in pointRegist"
                :key="idx"
                class="point-data"
              >
                <td class="pa-0">
                  <v-radio-group
                    v-model="radioSelect"
                    :disabled="editFlag !== 0 && editLocationMode !== 1"
                    class="py-0"
                  >
                    <v-radio
                      :value="radioGroup[idx].id"
                      class="rp-item-radio pa-0 pl-2"
                      @click="radioSelect = radioGroup[idx].id"
                    ></v-radio>
                  </v-radio-group>
                </td>
                <td class="rp-item-name pa-0 pl-2 my-0">
                  <v-text-field
                    :rules="rules"
                    :maxlength="maxLength"
                    clear-icon="cancel"
                    class="py-0 ma-0"
                    v-model="item.name"
                    @change="changePointName(idx)"
                  ></v-text-field>
                </td>
                <td v-if="item.address" class="py-0 pr-0 pl-1">
                  <span class="rp-text">{{ item.address }}</span>
                </td>
                <td class="rp-text py-0" v-if="!item.address">
                  <v-btn
                    outlined
                    x-small
                    :loading="
                      editFlag !== 0 &&
                        editLocationMode !== 1 &&
                        idx === registPointNum
                    "
                    :disabled="
                      editFlag !== 0 &&
                        editLocationMode !== 1 &&
                        idx !== registPointNum
                    "
                    color="success"
                    @click="regist(idx, item.name, editFlag)"
                    >{{ text.registration }}</v-btn
                  >
                </td>
                <td
                  v-if="isLoading(idx)"
                  colspan="2"
                  class="vc-item-add pa-0 pl-2"
                >
                  <v-row class="vc-td-loading">
                    <div v-if="item.address" class="vc-td-item-loading pl-2">
                      <!-- <v-progress-circular
                        :rotate="5"
                        :size="35"
                        :width="3"
                        :value="progressValue"
                        color="teal"
                      >
                        <span class="vc-td-value">{{ progressValue }}%</span>
                      </v-progress-circular> -->
                      <v-progress-linear
                        :value="progressValue"
                        height="25"
                        color="cyan lighten-2"
                      >
                        {{ progressValue }}%</v-progress-linear
                      >
                    </div>
                    <!-- <div class="vc-td-item-tooltip ">
                      <v-tooltip bottom max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="teal"
                            class="ml-2"
                            fab
                            >format_list_bulleted</v-icon
                          >
                        </template>
                        <span>
                          <v-icon v-if="registPointState >= 1" color="green"
                            >check_box</v-icon
                          >
                          <v-icon v-else color="green"
                            >check_box_outline_blank</v-icon
                          >
                          {{ text.rpStateName1 }}
                        </span>
                        <br />
                        <span>
                          <v-icon v-if="registPointState >= 2" color="green"
                            >check_box</v-icon
                          >
                          <v-icon v-else color="green"
                            >check_box_outline_blank</v-icon
                          >
                          {{ text.rpStateName2 }}
                        </span>
                        <br />
                        <span>
                          <v-icon v-if="registPointState >= 3" color="green"
                            >check_box</v-icon
                          >
                          <v-icon v-else color="green"
                            >check_box_outline_blank</v-icon
                          >
                          {{ text.rpStateName3 }}
                        </span>
                        <br />
                        <span>
                          <v-icon v-if="registPointState >= 4" color="green"
                            >check_box</v-icon
                          >
                          <v-icon v-else color="green"
                            >check_box_outline_blank</v-icon
                          >
                          {{ text.rpStateName4 }}
                        </span>
                      </v-tooltip>
                    </div> -->
                    <div class="vc-td-item-cancel">
                      <v-btn
                        class="ml-2"
                        x-small
                        outlined
                        color="success"
                        @click="registCancel(idx)"
                        >{{ text.cancel }}</v-btn
                      >
                    </div>
                  </v-row>
                </td>
                <td v-if="!isLoading(idx)" class="vc-item-add pa-0 pl-1">
                  <v-btn
                    v-if="item.address"
                    outlined
                    x-small
                    color="success"
                    class="rp-btn"
                    :loading="
                      editFlag !== 0 &&
                        editLocationMode !== 1 &&
                        idx === registPointNum
                    "
                    :disabled="editFlag !== 0 && editLocationMode !== 1"
                    @click="collectionRisk(idx)"
                  >
                    <span v-if="item.risk">{{ text.uppdate }}</span>
                    <span v-else>{{ text.collection }}</span>
                  </v-btn>
                </td>
                <td v-if="!isLoading(idx)" class="rp-item-del pa-0 pl-2">
                  <v-btn
                    v-if="item.address"
                    icon
                    outlined
                    x-small
                    color="success"
                    :disabled="editFlag !== 0 && editLocationMode !== 1"
                    @click="deletePoint(idx)"
                  >
                    <v-icon>clear</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-col>
    </v-col>
    <!-- 登録中の説明 -->
    <v-row
      v-if="editFlag !== 0 && editLocationMode !== 1"
      class="com-mb-card-contents-none-border rp-loading pa-0 pb-6 ma-0 "
    >
      <span class="rp-info mx-4 ">{{ registInfomation }}</span>
    </v-row>
    <v-row
      v-if="editFlag === 0"
      class="com-mb-card-contents-none-border rp-loading pa-0 pb-6 ma-0 "
    >
      <span class="rp-info mx-4 ">{{ text.info }}</span>
    </v-row>

    <!-- 登録地点の地図へのリンク -->
    <v-col class="rp-link pt-0">
      <!-- 登録地点の地図を開くボタン -->
      <v-btn
        class="rp-link-btn ml-2"
        small
        :disabled="editFlag !== 0 && editLocationMode !== 1"
        @click="clickLinkMap()"
      >
        <v-icon color="success">insert_link</v-icon>
        <span>{{ text.map }}</span>
      </v-btn>
    </v-col>
    <!-- 登録地点の地図を開くボタンのメッセージ -->
    <v-row
      v-if="type === 'top' && editFlag !== 0 && editLocationMode !== 1"
      class="com-mb-card-contents-none-border rp-loading pa-0 pb-4 ma-0 "
    >
      <span class="rp-info mx-4 ">{{ text.mapBtnText }}</span>
    </v-row>

    <!-- リンク -->
    <v-col class="rp-link pt-0">
      <!-- リアルタイムマイタイムラインボタン -->
      <v-btn
        v-if="type === 'mt'"
        class="rp-link-btn ml-2"
        small
        :href="clickLink(type)"
      >
        <v-icon color="success">insert_link</v-icon>
        <span>{{ text.myTimeline }}</span>
      </v-btn>
      <!-- マルチモニタボタン -->
      <v-btn
        v-if="type === 'pt'"
        class="rp-link-btn ml-2"
        small

        :href="clickLink(type)"
      >
        <v-icon color="success">insert_link</v-icon>
        <span>{{ text.portal }}</span>
      </v-btn>
      <!-- トップボタン -->
      <v-btn
        v-if="type === 'top'"
        class="rp-link-btn ml-2"
        small

        :href="clickLink(type)"
      >
        <v-icon color="success">insert_link</v-icon>
        <span>{{ text.top }}</span>
      </v-btn>
    </v-col>
    
  </v-container>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 表示設定 登録地点カード
 * VcPoint.vue
 * @author LIS
 */
import WebStorage from "./../../lib/webStorage.js";

export default {
  name: "vc-point",
  data() {
    return {
      pointRegist: [],
      registFlgPoint: false,
      radioSelect: "",
      radioGroup: [{ id: "point1" }, { id: "point2" }, { id: "point3" }, { id: "point4" }, { id: "point5" }],
      type: "",
      rules: [
        (v) =>
          v.length <= this.maxLength ||
          this.maxLength + "字以内で登録してください。",
      ],
      /** 文字列リソース */
      text: {
        registrationPoint: "登録地点",
        help:
          "地点登録すると、地図上にホームアイコンが表示され、" +
          "影響のある河川の水位情報や浸水の影響度合いを見ることができます。",
        info: "「登録」ボタンを押して地点登録を開始します。",
        select: "選択",
        pointName: "地点名",
        location: "所在地",
        riskInfo: "リスク情報",
        relatedOb: "関連観測所",
        delete: "削除",
        registration: "登録",
        add: "追加",
        collection: "リスク判定する",
        uppdate: "リスク再判定",
        myTimelineText: "所在地登録する地点を選択して下さい。",
        myTimelineBtnText:
          "登録中、あるいは未登録を選択している場合は、リアルタイムマイ・タイムラインへ戻るボタンは押せません。",
        topBtnText:
          "登録中、あるいは未登録を選択している場合は、トップへ戻るボタンは押せません。",
        portalBtnText:
          "登録中、あるいは未登録を選択している場合は、マルチモニタへ戻るボタンは押せません。",
        mapBtnText: "登録中の場合は、登録地点の地図を開くボタンは押せません。",
        top: "トップへ戻る",
        portal: "マルチモニタへ戻る",
        myTimeline: "リアルタイムマイ・タイムラインへ戻る",
        map: "登録地点の地図を開く",
        rpStateName1: "3時間以内に浸水深50cmになる破堤点取得",
        rpStateName2: "河川毎最大浸水深取得",
        rpStateName3: "河川毎最速到達時間取得",
        rpStateName4: "河川毎最大継続時間取得",
        cancel: "キャンセル",
      },
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[RpPoint] mounted()");
    this.init();
    this.myTimelineFlg(this.radioSelect);
    this.dispType();
  },
  computed: {
    /** 登録地点読み込み日時 */
    editWebStorageDate: {
      get() {
        return this.$store.state.map.editWebStorageDate;
      },
    },
    /** 登録地編集モード [0:未編集, 1:地図選択, 2:登録確認] */
    editLocationMode: {
      get() {
        return this.$store.state.map.editLocationMode;
      },
    },
    /** 選択地点番号 */
    selectedPoint: {
      get() {
        return this.$store.state.viewConfig.selectedPoint;
      },
    },
    /** 登録中フラグ */
    editFlag: {
      get() {
        return this.$store.state.map.editFlag;
      },
    },
    /** 地点登録番号 */
    registPointNum: {
      get() {
        return this.$store.state.viewConfig.registPointNum;
      },
    },
    /** LocalStrageの初期表示情報(default) */
    localStrageDefault: {
      get() {
        return JSON.parse(localStorage.getItem("default"));
      },
    },
    /** 登録地点名の最大文字数 */
    maxLength: {
      get() {
        return this.$store.state.app.config.registConfig
          .maxRegistPointNameLength;
      },
    },
    /** 登録中メッセージ */
    registInfomation: {
      get() {
        return this.$store.state.app.config.registConfig.registInfomation;
      },
    },
    /** リンク一覧 */
    link: {
      get() {
        return this.$store.state.app.config.registConfig.link;
      },
    },
    /** 選択値 */
    value: {
      get() {
        return {
          point: this.radioSelect,
        };
      },
    },
    /** 地点登録状況 */
    registPointState: {
      get() {
        return this.$store.state.Telemeter.registPointState;
      },
    },
    /** プログレスの値 */
    progressValue: {
      get() {
        let val = (this.$store.state.Telemeter.registPointState / 4) * 100;
        return val;
      },
    },
  },
  watch: {
    /** 地図の登録地点が読み直された場合、コンポーネントも再表示 */
    editWebStorageDate() {
      this.$log.debug("[RpPoint] watch(editWebStorageDate)");
      this.init();
      this.myTimelineFlg(this.radioSelect);
    },
    /** */
    value() {
      this.$log.debug("[RpPoint] watch(value)");
      this.myTimelineFlg(this.radioSelect);
    },
  },
  methods: {
    /** 表示項目初期化 */
    init() {
      this.$log.debug("[RpPoint] init()");
      // webストレージから表示情報を取得
      let point1 = WebStorage.getPoint1Info();
      this.$log.debug("[RpPoint] init point1");
      this.$log.dir(point1);
      let point2 = WebStorage.getPoint2Info();
      this.$log.debug("[RpPoint] init point2");
      this.$log.dir(point2);
      let point3 = WebStorage.getPoint3Info();
      this.$log.debug("[RpPoint] init point3");
      this.$log.dir(point3);
      let point4 = WebStorage.getPoint4Info();
      this.$log.debug("[RpPoint] init point4");
      this.$log.dir(point4);
      let point5 = WebStorage.getPoint5Info();
      this.$log.debug("[RpPoint] init point5");
      this.$log.dir(point5);

      this.pointRegist = [
        {
          name: point1 ? point1.name : "",
          address: point1 ? point1.address : "",
          risk: point1 ? point1.risk : "",
        },
        {
          name: point2 ? point2.name : "",
          address: point2 ? point2.address : "",
          risk: point2 ? point2.risk : "",
        },
        {
          name: point3 ? point3.name : "",
          address: point3 ? point3.address : "",
          risk: point3 ? point3.risk : "",
        },
        {
          name: point4 ? point4.name : "",
          address: point4 ? point4.address : "",
          risk: point4 ? point4.risk : "",
        },
        {
          name: point5 ? point5.name : "",
          address: point5 ? point5.address : "",
          risk: point5 ? point5.risk : "",
        },
      ];
      // 選択ボタンの設定
      if (point1) {
        if (point1.myTimeline) {
          this.radioSelect = "point1";
        }
      }
      if (point2) {
        if (point2.myTimeline) {
          this.radioSelect = "point2";
        }
      }
      if (point3) {
        if (point3.myTimeline) {
          this.radioSelect = "point3";
        }
      }
      if (point4) {
        if (point4.myTimeline) {
          this.radioSelect = "point4";
        }
      }
      if (point5) {
        if (point5.myTimeline) {
          this.radioSelect = "point5";
        }
      }
      // myTimelineがない場合は、初期値のpoint1を設定
      if (!this.radioSelect) {
        this.radioSelect = "point1";
      }
    },
    /** 登録ボタン押下 */
    regist(index, name, flag) {
      this.$log.debug(
        "[RpPoint] regist(" + index + "," + name + "," + flag + ")"
      );
      switch (index) {
        case 0:
          if (name === "") {
            this.$log.debug("[RpPoint] name 1 change to default.");
            name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "１";
          }
          break;
        case 1:
          if (name === "") {
            this.$log.debug("[RpPoint] name 2 change to default.");
            name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "２";
          }
          break;
        case 2:
          if (name === "") {
            this.$log.debug("[RpPoint] name 3 change to default.");
            name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "３";
          }
          break;
        case 3:
          if (name === "") {
            this.$log.debug("[RpPoint] name 4 change to default.");
            name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "４";
          }
          break;
        case 4:
          if (name === "") {
            this.$log.debug("[RpPoint] name 5 change to default.");
            name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "５";
          }
          break;
      }
      this.$store.commit("map/setEditLocationMode", 1);
      this.$store.commit("viewConfig/setSelectedPointName", name);
      this.$store.commit("viewConfig/setSelectedPoint", index);
      this.$store.commit("viewConfig/setRegistPointNum", index);
      this.$store.commit("map/setEditFlag", flag);
    },
    /** 地点名変更時 */
    changePointName(index) {
      this.$log.debug("[RpPoint] changePointName(" + index + ")");
      switch (index) {
        case 0:
          this.$log.debug("[RpPoint] changePointName index == 0");
          var point1 = WebStorage.getPoint1Info();
          point1 = point1 ? point1 : {};
          if (this.pointRegist[index].name === "") {
            point1.name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "１";
          } else {
            point1.name = this.pointRegist[index].name;
          }
          WebStorage.setPoint1Info(point1);
          break;
        case 1:
          this.$log.debug("[RpPoint] changePointName index == 1");
          var point2 = WebStorage.getPoint2Info();
          point2 = point2 ? point2 : {};
          if (this.pointRegist[index].name === "") {
            point2.name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "２";
          } else {
            point2.name = this.pointRegist[index].name;
          }
          WebStorage.setPoint2Info(point2);
          break;
        case 2:
          this.$log.debug("[RpPoint] changePointName index == 2");
          var point3 = WebStorage.getPoint3Info();
          point3 = point3 ? point3 : {};
          if (this.pointRegist[index].name === "") {
            point3.name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "３";
          } else {
            point3.name = this.pointRegist[index].name;
          }
          WebStorage.setPoint3Info(point3);
          break;
        case 3:
          this.$log.debug("[RpPoint] changePointName index == 3");
          var point4 = WebStorage.getPoint4Info();
          point4 = point4 ? point4 : {};
          if (this.pointRegist[index].name === "") {
            point4.name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "４";
          } else {
            point4.name = this.pointRegist[index].name;
          }
          WebStorage.setPoint4Info(point4);
          break;
        case 4:
          this.$log.debug("[RpPoint] changePointName index == 4");
          var point5 = WebStorage.getPoint5Info();
          point5 = point5 ? point5 : {};
          if (this.pointRegist[index].name === "") {
            point5.name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "５";
          } else {
            point5.name = this.pointRegist[index].name;
          }
          WebStorage.setPoint5Info(point5);
          break;
      }
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 地点削除時 */
    deletePoint(index) {
      this.$log.debug("[RpPoint] deletePoint(" + index + ")");

      this.$store.commit("viewConfig/setSelectedPoint", index);
      this.$store.commit("viewConfig/setRegistPointNum", index);

      // 確認ダイアログ
      this.$store.commit("viewConfig/setDeleteFlg", 1);
    },
    /** リンククリック時 */
    clickLink(type) {
      this.$log.debug("[RpPoint] clickLink(" + type + ")");
      let url = "";
      // typeからURLを設定
      if (type === "mt") {
        url = this.link[2].url;
      } else if (type === "pt") {
        url = this.link[1].url;
      } else if (type === "top") {
        url = this.link[0].url;
      }
      return url;
    },
    /** 地図用リンク */
    clickLinkMap() {
      let isInfo = false;
      let idx = 0;
      let url = "";

      // 初期表示設定に地点が選択されている場合は、そこに遷移
      let info = WebStorage.getDefaultInfo();
      if (info && info.point1) {
        isInfo = true;
        idx = 0;
      } else if (info && info.point2) {
        isInfo = true;
        idx = 1;
      } else if (info && info.point3) {
        isInfo = true;
        idx = 2;
      } else if (info && info.point4) {
        isInfo = true;
        idx = 3;
      } else if (info && info.point5) {
        isInfo = true;
        idx = 4;
      }

      // 初期表示設定が全国の場合は、登録されている一番上の地点に遷移
      if (!isInfo) {
        for (let i = 1; i <= WebStorage.length(); i++) {
          info = WebStorage.getPointInfo(i);
          if (info != null && info.name != null && info.pointIndex != null) {
            isInfo = true;
            idx = i - 1;
            break;
          }
        }
      }

      if (isInfo) {
        // 登録地点情報へ遷移
        url = this.link[4].url + "?pidx=" + idx;
      } else {
        // 表示設定へ遷移
        let zm = this.$route.query["zm"];
        let clat = this.$route.query["clat"];
        let clon = this.$route.query["clon"];
        url =
          this.link[3].url + "?zm=" + zm + "&clat=" + clat + "&clon=" + clon;
      }
      window.location.href = url;
    },
    /** 選択されている地点をウェブストレージに登録 */
    myTimelineFlg(point) {
      this.$log.debug("[RpPoint] myTimelineFlg(" + point + ")");
      // webストレージから表示情報を取得
      let point1 = WebStorage.getPoint1Info();
      let point2 = WebStorage.getPoint2Info();
      let point3 = WebStorage.getPoint3Info();
      let point4 = WebStorage.getPoint4Info();
      let point5 = WebStorage.getPoint5Info();
      this.radioSelect = point;
      if (point === "point1") {
        point1 ? (point1.myTimeline = true) : "";
        point2 ? (point2.myTimeline = false) : "";
        point3 ? (point3.myTimeline = false) : "";
        point4 ? (point4.myTimeline = false) : "";
        point5 ? (point5.myTimeline = false) : "";
        WebStorage.setPoint1Info(point1);
        WebStorage.setPoint2Info(point2);
        WebStorage.setPoint3Info(point3);
        WebStorage.setPoint4Info(point4);
        WebStorage.setPoint5Info(point5);
        // リアルタイムマイタイムの遷移ボタンの設定
        if (point1) {
          point1.myTimeline
            ? (this.registFlgPoint = true)
            : (this.registFlgPoint = false);
        } else {
          this.registFlgPoint = false;
        }
      } else if (point === "point2") {
        point1 ? (point1.myTimeline = false) : "";
        point2 ? (point2.myTimeline = true) : "";
        point3 ? (point3.myTimeline = false) : "";
        point4 ? (point4.myTimeline = false) : "";
        point5 ? (point5.myTimeline = false) : "";
        WebStorage.setPoint1Info(point1);
        WebStorage.setPoint2Info(point2);
        WebStorage.setPoint3Info(point3);
        WebStorage.setPoint4Info(point4);
        WebStorage.setPoint5Info(point5);
        if (point2) {
          point2.myTimeline
            ? (this.registFlgPoint = true)
            : (this.registFlgPoint = false);
        } else {
          this.registFlgPoint = false;
        }
      } else if (point === "point3") {
        point1 ? (point1.myTimeline = false) : "";
        point2 ? (point2.myTimeline = false) : "";
        point3 ? (point3.myTimeline = true) : "";
        point4 ? (point4.myTimeline = false) : "";
        point5 ? (point5.myTimeline = false) : "";
        WebStorage.setPoint1Info(point1);
        WebStorage.setPoint2Info(point2);
        WebStorage.setPoint3Info(point3);
        WebStorage.setPoint4Info(point4);
        WebStorage.setPoint5Info(point5);
        if (point3) {
          point3.myTimeline
            ? (this.registFlgPoint = true)
            : (this.registFlgPoint = false);
        } else {
          this.registFlgPoint = false;
        }
      } else if (point === "point4") {
        point1 ? (point1.myTimeline = false) : "";
        point2 ? (point2.myTimeline = false) : "";
        point3 ? (point3.myTimeline = false) : "";
        point4 ? (point4.myTimeline = true) : "";
        point5 ? (point5.myTimeline = false) : "";
        WebStorage.setPoint1Info(point1);
        WebStorage.setPoint2Info(point2);
        WebStorage.setPoint3Info(point3);
        WebStorage.setPoint4Info(point4);
        WebStorage.setPoint5Info(point5);
        if (point4) {
          point4.myTimeline
            ? (this.registFlgPoint = true)
            : (this.registFlgPoint = false);
        } else {
          this.registFlgPoint = false;
        }
      } else if (point === "point5") {
        point1 ? (point1.myTimeline = false) : "";
        point2 ? (point2.myTimeline = false) : "";
        point3 ? (point3.myTimeline = false) : "";
        point4 ? (point4.myTimeline = false) : "";
        point5 ? (point5.myTimeline = true) : "";
        WebStorage.setPoint1Info(point1);
        WebStorage.setPoint2Info(point2);
        WebStorage.setPoint3Info(point3);
        WebStorage.setPoint4Info(point4);
        WebStorage.setPoint5Info(point5);
        if (point5) {
          point5.myTimeline
            ? (this.registFlgPoint = true)
            : (this.registFlgPoint = false);
        } else {
          this.registFlgPoint = false;
        }
      }
    },
    /** クエリパラメータのtypeを設定 */
    dispType() {
      this.$log.debug("[RpPoint] dispType()");
      let type = this.$route.query["type"];
      this.type = type;
    },
    /** リスク情報の収集 */
    collectionRisk(index) {
      this.$log.debug("[VcPoint] collectionRisk(" + index + ")");

      // リスク収集ボタン押下時に行を選択
      switch (index) {
        case 0:
          this.radioSelect = "point1";
          break;
        case 1:
          this.radioSelect = "point2";
          break;
        case 2:
          this.radioSelect = "point3";
          break;
        case 3:
          this.radioSelect = "point4";
          break;
        case 4:
          this.radioSelect = "point5";
          break;
      }

      this.$store.commit("viewConfig/setSelectedPoint", index);
      this.$store.commit("viewConfig/setRegistPointNum", index);

      // 確認ダイアログ
      this.$store.commit("viewConfig/setRiskFlg", 1);
    },
    /** 読込中 */
    isLoading(idx) {
      if (
        this.editFlag !== 0 &&
        this.editLocationMode !== 1 &&
        idx === this.registPointNum
      ) {
        return true;
      } else {
        return false;
      }
    },
    /** 登録キャンセル */
    registCancel(index) {
      this.$log.debug("[VcPoint] registCancel(" + index + ")");

      // ステータスをクリア
      this.$store.commit("map/setEditLocationMode", 0);
      this.$store.commit("map/setEditTmMode", 0);
      this.$store.commit("map/setEditFlag", 0);

      // 地点登録状況に9:キャンセルを設定
      this.$store.commit("Telemeter/setRegistPointState", 9);
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.rp-point {
  .rp-point-card {
    .rp-point-contents {
      .rp-box {
        display: flex;
        flex-direction: row;
        .rp-table {
          flex: 1;
        }
      }
    }
  }

  .point-data {
    cursor: pointer;
    height: 40px;
  }
  .v-text-field {
    font-size: 0.65rem;
    margin-left: 8px;
  }
  .rp-text {
    font-size: 0.7rem;
  }
  .rp-item-radio {
    width: 20px;
    font-size: 0.7rem;
  }
  .rp-item-name {
    width: 70px;
    font-size: 0.7rem;
  }
  .rp-item-location {
    width: 60px;
    font-size: 0.7rem;
  }
  .rp-item-riskInfo {
    width: 100px;
    font-size: 0.7rem;
  }
  .rp-item-del {
    width: 32px;
    font-size: 0.7rem;
  }
  .rp-loading {
    display: flex;
    flex-direction: row;
    .rp-info {
      font-size: 0.8rem;
    }
  }

  .vc-td-loading {
    display: flex;
    align-items: center;
    .vc-td-item-loading {
      display: flex;
      justify-content: flex-end;
      width: 70px;
      .vc-td-value {
        font-size: 0.7rem;
      }
    }
    .vc-td-item-tooltip {
      display: flex;
      flex-direction: row;
    }
    .vc-td-item-cancel {
      flex: 1;
    }
  }

  .rp-btn {
    font-size: 0.7rem;
  }

  .rp-link {
    display: flex;
    flex-direction: column;
    .rp-link-btn {
      justify-content: flex-start;
      width: 280px;
    }
  }
}
</style>
